export default function(v: string | null): string {
  if (!v) return "€ 0,00";

  v = (Math.round(Number(v) * 100) / 100).toString();
  var parts = v.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  parts[1] = (parts[1] ? parts[1] : "").padEnd(2, "0");
  return "€ " + parts.join(",");
}
